import type { ReactNode } from "react";
import { Phone } from "lucide-react";
import { SITE_DETAILS } from "@shared/site";
import { SiteFooter } from "./SiteFooter";
import { SiteHeader } from "./SiteHeader";

type SiteLayoutProps = {
  children: ReactNode;
  mainClassName?: string;
};

export function SiteLayout({ children, mainClassName }: SiteLayoutProps) {
  return (
    <div className="site-shell">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <SiteHeader />
      <main id="main-content" tabIndex={-1} className={mainClassName}>{children}</main>
      <SiteFooter />
      <a className="mobile-sticky-call" href={SITE_DETAILS.phoneHref}>
        <Phone size={18} aria-hidden="true" /> Call {SITE_DETAILS.phoneDisplay}
      </a>
    </div>
  );
}
